import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Grid, Row } from 'react-styled-flexboxgrid-tmp'
import { scroller } from 'react-scroll'
import ReactGA from 'react-ga4'

import { MenuPanel } from 'Components/MenuPanel'
import Pagination from './Pagination'


// import css from './styles.js'
import {
  _Grid, _Pagination, _PaginatedList, _ListWrapper,
  _List,
} from './styles'


class PaginatedList extends Component {
  constructor(props) {
    super(props)
    this.renderPaginationList = this.renderPaginationList.bind(this)
    this.onPaginationClick = this.onPaginationClick.bind(this)
  }
  onPaginationClick(currentPageNum, offer) {
    ReactGA.event({
      category: 'For ' + offer,
      action: 'pagination',
      label: currentPageNum.toString(),
      value: currentPageNum,
    })
    const extraContainerId = (this.props.containerId || '')
    // search page scroller does not work
    const elem = this.props.scrollToElementSelector
    if(elem) {
      scroller.scrollTo(elem, {
        duration: 0,
        delay: 0,
        smooth: true,
        containerId: 'contentView',
        offset: -150,
      })
    } else {
      scroller.scrollTo('listRow' + extraContainerId, {
        duration: 0,
        delay: 0,
        smooth: false,
        containerId: 'listContainer' + extraContainerId,
        offset: -200,
      })
    }
  }
  renderPaginationList() {
    const {
      location,
      pagination: { perPage, currentPage, total },
      gridNumber,
      offer,
      justifyRight,
      fixedPosition,
    } = this.props
    return (
      <_Pagination
        center="xs"
        fixedPosition={fixedPosition}
        justifyRight={justifyRight ? 1 : 0}
      >
        {
          gridNumber ?
            <MenuPanel
              gridNumber={gridNumber}
              location={location}
              offer={offer}
            >
              <Pagination
                location={location}
                perPage={perPage}
                currentPage={currentPage}
                totalCount={total}
                offer={offer}
                onPaginationClick={this.onPaginationClick.bind(this)}
              />
            </MenuPanel>
            :
            <Pagination
              location={location}
              perPage={perPage}
              currentPage={currentPage}
              totalCount={total}
              offer={offer}
              onPaginationClick={this.onPaginationClick.bind(this)}
            />
        }
      </_Pagination>
    )
  }

  render() {
    const {
      children,
      cssGridStyle,
      fixedPosition,
      gridNumber,
      getListContainerRef = () => {},
      containerId = '',
    } = this.props
    return (
      <div>
        <_PaginatedList
          fluid
          fixedPosition={fixedPosition}
        >
          {
            cssGridStyle ?
              <_Grid>
                { children }
              </_Grid> :
              <_ListWrapper
                id={'listContainer' + containerId}
                // style={listWrapperStyle}
                ref={getListContainerRef}
                fixedPosition={fixedPosition}
              >
                <_List
                  isSmallList={gridNumber > 6}
                  id={'listRow' + containerId}
                  fixedPosition={fixedPosition}
                >
                  { children }
                </_List>
              </_ListWrapper>
          }
          {
            cssGridStyle && this.renderPaginationList()
          }

        </_PaginatedList>
        {!cssGridStyle && this.renderPaginationList()}
      </div>
    )
  }
}

PaginatedList.propTypes = {
  children: PropTypes.node.isRequired,
  cssGridStyle: PropTypes.bool,

  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,

  pagination: PropTypes.shape({
    total: PropTypes.number,
    perPage: PropTypes.number,
    currentPage: PropTypes.number,
  }).isRequired,

  fixedPosition: PropTypes.bool,
  justifyRight: PropTypes.bool,

  gridNumber: PropTypes.number,
  offer: PropTypes.string,
  containerId: PropTypes.string,
  getListContainerRef: PropTypes.func,
  scrollToElementSelector: PropTypes.string,
}

export default PaginatedList
